(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rooms-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customElements.get('rooms-grid')) {
    return;
  }

  var SWIPE = 50;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  class RoomsGrid extends HTMLElement {
    connectedCallback() {
      if (this._init) {
        return;
      }

      this.gridView = this.querySelector('[data-cbr-grid]');
      this.lightbox = this.querySelector('[data-cbr-lightbox]');
      if (!this.gridView || !this.lightbox) {
        return;
      }

      this._init = true;
      this.deepLinks = this.getAttribute('data-deep-links') === 'true';

      this.stage = this.querySelector('[data-cbr-stage]');
      this.slidesEl = this.querySelector('[data-cbr-slides]');
      this.prevBtn = this.querySelector('[data-cbr-prev]');
      this.nextBtn = this.querySelector('[data-cbr-next]');
      this.capEl = this.querySelector('[data-cbr-caption]');
      this.cntEl = this.querySelector('[data-cbr-counter]');
      this.dotsEl = this.querySelector('[data-cbr-dots]');
      this.nameEl = this.querySelector('[data-cbr-name]');
      this.secEl = this.querySelector('[data-cbr-section]');
      this.sleepsEl = this.querySelector('[data-cbr-sleeps]');
      this.bedEl = this.querySelector('[data-cbr-bed]');
      this.bathEl = this.querySelector('[data-cbr-bath]');
      this.featureEl = this.querySelector('[data-cbr-feature]');
      this.descEl = this.querySelector('[data-cbr-desc]');

      this.rooms = {};
      var dataEl = this.querySelector('[data-cbr-rooms]');
      if (dataEl) {
        try {
          this.rooms = JSON.parse(dataEl.textContent);
        } catch (e) {
          this.rooms = {};
        }
      }

      this.templates = {};
      toArray(this.querySelectorAll('[data-cbr-room-tpl]')).forEach(function (t) {
        this.templates[t.getAttribute('data-cbr-room-tpl')] = t;
      }, this);

      this.cards = toArray(this.querySelectorAll('[data-cbr-card]'));
      this.order = this.cards.map(function (c) {
        return c.getAttribute('data-room-id');
      });
      this.roomIds = {};
      this.order.forEach(function (id) {
        this.roomIds[id] = true;
      }, this);

      this.currentRoom = null;
      this.photoIndex = 0;
      this.slides = [];
      this.lastFocus = null;

      this._bind();
      this._portal();
      this._initFromUrl();
    }

    disconnectedCallback() {
      this._unlockScroll();
      if (this._portaled && this.lightbox && this.lightbox.parentNode) {
        this.lightbox.parentNode.removeChild(this.lightbox);
      }
    }

    // Déplace la fenêtre directement sous <body> pour qu'elle se superpose
    // vraiment à toute la page (sinon un parent peut la "piéger" et le clic
    // sur le fond ne ferme pas).
    _portal() {
      if (this.lightbox && document.body && this.lightbox.parentNode !== document.body) {
        document.body.appendChild(this.lightbox);
        this._portaled = true;
      }
    }

    _designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    _isOpen() {
      return this.lightbox && !this.lightbox.hasAttribute('hidden');
    }

    _bind() {
      var self = this;

      this.cards.forEach(function (card) {
        var id = card.getAttribute('data-room-id');
        card.addEventListener('click', function () {
          self.open(id);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            self.open(id);
          }
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () { self.photoStep(-1); });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () { self.photoStep(1); });
      }

      toArray(this.querySelectorAll('[data-cbr-close]')).forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });

      if (this.lightbox) {
        this.lightbox.addEventListener('click', function (e) {
          if (!e.target.closest('.cbr-lb-panel')) {
            self.close();
          }
        });
      }
      toArray(this.querySelectorAll('[data-cbr-prev-room]')).forEach(function (b) {
        b.addEventListener('click', function () { self.roomStep(-1); });
      });
      toArray(this.querySelectorAll('[data-cbr-next-room]')).forEach(function (b) {
        b.addEventListener('click', function () { self.roomStep(1); });
      });

      document.addEventListener('keydown', function (e) {
        if (!self._isOpen()) {
          return;
        }
        if (e.key === 'Escape') {
          self.close();
        } else if (e.key === 'ArrowRight') {
          self.photoStep(1);
        } else if (e.key === 'ArrowLeft') {
          self.photoStep(-1);
        }
      });

      if (this.stage) {
        var sx = 0;
        var sy = 0;
        var tracking = false;
        this.stage.addEventListener('touchstart', function (e) {
          var t = e.changedTouches[0];
          sx = t.clientX;
          sy = t.clientY;
          tracking = true;
        }, { passive: true });
        this.stage.addEventListener('touchend', function (e) {
          if (!tracking) {
            return;
          }
          tracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - sx;
          var dy = t.clientY - sy;
          if (Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy)) {
            self.photoStep(dx < 0 ? 1 : -1);
          }
        }, { passive: true });
      }

      if (this.deepLinks && !this._designMode()) {
        window.addEventListener('popstate', function () { self._syncFromUrl(); });
      }
    }

    _param() {
      try {
        return new URLSearchParams(window.location.search).get('room');
      } catch (e) {
        return null;
      }
    }

    _setParam(id) {
      if (!this.deepLinks || this._designMode()) {
        return;
      }
      try {
        var params = new URLSearchParams(window.location.search);
        if (id) {
          params.set('room', id);
        } else {
          params.delete('room');
        }
        var qs = params.toString();
        var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        window.history.pushState({ cbrRoom: id || null }, '', url);
      } catch (e) {}
    }

    _initFromUrl() {
      if (!this.deepLinks) {
        return;
      }
      var id = this._param();
      if (id && this.roomIds[id]) {
        this.open(id, true);
      }
    }

    _syncFromUrl() {
      var id = this._param();
      if (id && this.roomIds[id]) {
        this.open(id, true);
      } else if (this._isOpen()) {
        this.close(true);
      }
    }

    open(id, fromUrl) {
      if (!this.roomIds[id]) {
        return;
      }
      if (!fromUrl) {
        this.lastFocus = document.activeElement;
      }
      this.currentRoom = id;
      this.photoIndex = 0;
      this._populate(id);
      this._renderMeta(id);
      this.lightbox.removeAttribute('hidden');
      this._lockScroll();
      if (!fromUrl) {
        this._setParam(id);
      }
      var closeBtn = this.lightbox.querySelector('[data-cbr-close]');
      if (closeBtn) {
        try {
          closeBtn.focus({ preventScroll: true });
        } catch (e) {
          closeBtn.focus();
        }
      }
    }

    _lockScroll() {
      if (this._scrollLocked) {
        return;
      }
      this._scrollLocked = true;
      this._prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    _unlockScroll() {
      if (!this._scrollLocked) {
        return;
      }
      this._scrollLocked = false;
      document.body.style.overflow = this._prevOverflow || '';
    }

    close(fromUrl) {
      this.lightbox.setAttribute('hidden', '');
      this._unlockScroll();
      this.currentRoom = null;
      if (!fromUrl) {
        this._setParam(null);
      }
      if (this.lastFocus && this.lastFocus.focus) {
        try {
          this.lastFocus.focus();
        } catch (e) {}
      }
      this.lastFocus = null;
    }

    _populate(id) {
      if (!this.slidesEl) {
        return;
      }
      this.slidesEl.innerHTML = '';
      var tpl = this.templates[id];
      if (tpl && tpl.content) {
        this.slidesEl.appendChild(tpl.content.cloneNode(true));
      }
      this.slides = toArray(this.slidesEl.querySelectorAll('[data-cbr-slide]'));
      this._buildDots();
      this._showPhoto(0);
      var multi = this.slides.length > 1;
      if (this.prevBtn) {
        this.prevBtn.style.display = multi ? '' : 'none';
      }
      if (this.nextBtn) {
        this.nextBtn.style.display = multi ? '' : 'none';
      }
    }

    _renderMeta(id) {
      var r = this.rooms[id] || {};
      if (this.nameEl) { this.nameEl.textContent = r.name || ''; }
      if (this.secEl) { this.secEl.textContent = r.section || ''; }
      if (this.sleepsEl) { this.sleepsEl.textContent = r.sleeps || ''; }
      if (this.bedEl) { this.bedEl.textContent = r.bed || ''; }
      if (this.bathEl) { this.bathEl.textContent = r.bath || ''; }
      if (this.descEl) { this.descEl.textContent = r.desc || ''; }
      if (this.featureEl) {
        if (r.feature) {
          this.featureEl.textContent = r.feature;
          this.featureEl.removeAttribute('hidden');
        } else {
          this.featureEl.textContent = '';
          this.featureEl.setAttribute('hidden', '');
        }
      }
    }

    _showPhoto(i) {
      var n = this.slides.length;
      if (!n) {
        if (this.capEl) { this.capEl.textContent = ''; }
        if (this.cntEl) { this.cntEl.textContent = ''; }
        return;
      }
      this.photoIndex = ((i % n) + n) % n;
      for (var k = 0; k < n; k++) {
        this.slides[k].classList.toggle('is-active', k === this.photoIndex);
      }
      var active = this.slides[this.photoIndex];
      if (this.capEl) {
        this.capEl.textContent = active ? (active.getAttribute('data-caption') || '') : '';
      }
      if (this.cntEl) {
        this.cntEl.textContent = (this.photoIndex + 1) + ' / ' + n;
      }
      this._updateDots();
    }

    photoStep(d) {
      this._showPhoto(this.photoIndex + d);
    }

    _buildDots() {
      if (!this.dotsEl) {
        return;
      }
      this.dotsEl.innerHTML = '';
      var n = this.slides.length;
      if (n < 2) {
        return;
      }
      var self = this;
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'cbr-lb-dot';
          d.setAttribute('aria-label', 'Go to photo ' + (idx + 1));
          d.addEventListener('click', function () { self._showPhoto(idx); });
          self.dotsEl.appendChild(d);
        })(i);
      }
    }

    _updateDots() {
      if (!this.dotsEl) {
        return;
      }
      var dots = this.dotsEl.querySelectorAll('.cbr-lb-dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === this.photoIndex);
      }
    }

    roomStep(dir) {
      if (!this.order.length) {
        return;
      }
      var idx = this.order.indexOf(this.currentRoom);
      if (idx < 0) {
        idx = 0;
      }
      idx = (idx + dir + this.order.length) % this.order.length;
      this.open(this.order[idx]);
    }
  }

  window.customElements.define('rooms-grid', RoomsGrid);
})();

  } catch(e) { console.error(e); }
})();
})();
